/**
 * Pourcentage signé du multiplicateur de prévision (« Ajuster la prévision », corrections, calcul).
 * Testé par `signed-percent.test.mjs`.
 *
 * Signe moins typographique (U+2212, « −5 % ») partout où ce libellé s'affiche (curseur et ses
 * graduations, modale « Corriger », calcul détaillé), comme les écarts de la logistique
 * (`operations-cost.ts`) ; les formateurs du module (`formatPercent` avec `signed`) écrivent un
 * trait d'union.
 */

import { formatPercentMax } from '@gozoki/tools'

const MINUS = '−'

/**
 * « +12 % », « −5 % », « 0 % », « +1 234 % » (au plus trois décimales, espace insécable, milliers
 * groupés). Le signe suit la valeur arrondie : jamais « +0 % » ni « −0 % ».
 */
export function formatSignedPercent(percent: number): string {
  // `signed` du module : signe de la valeur arrondie ; seul le trait d'union est remplacé.
  return formatPercentMax(percent, 3, { signed: true }).replace(/^-/, MINUS)
}
